// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-cdb1dc98]{width:123px;height:24px;margin:0 8px}.logo img[data-v-cdb1dc98]{width:100%;height:100%;background-size:cover}@media(min-width:1280px){.logo[data-v-cdb1dc98]{margin:0}}", ""]);
// Exports
module.exports = exports;
